import React from "react";
import FetchActiveUploads from "./fetch-active-uploads";
import IconUploadList from "./active-upload-list";
import UploadsLinks from "../uploads-links";

const DashboardUploadsSection = ({ showIcons, username, userUploads }) =>
    showIcons && (
        <section id="user-uploads" className="clearfix profile-section">
            <div className="container row">
                <header className="display-flex col-xs-12">
                    <h3 className="ui_upload">Icon Submissions</h3>
                    <UploadsLinks
                        username={username}
                        userUploads={userUploads}
                    />
                </header>

                <div className="col-xs-12">
                    <FetchActiveUploads>
                        <IconUploadList />
                    </FetchActiveUploads>
                </div>
            </div>
        </section>
    );

export default DashboardUploadsSection;
